import React from 'react'
import Reflux from 'reflux'
import { Link } from 'react-router-dom'
import { Alert, Container, Card, CardHeader, CardBody, Button, Row, Col } from 'reactstrap'
import FontAwesome from 'react-fontawesome'

import CurrentRecipeActions from '~/actions/currentRecipe.js'

import CurrentRecipeStore from '~/stores/currentRecipe.js'

import OnlyIfAuthorized from '~/modules/onlyIfAuthorized/index.jsx'
import RecipeEditGeneral from '~/modules/details/general.jsx'
import RecipeEditIngredientsEdit from '~/modules/recipeIngredients/edit.jsx'
import RecipeEditInstructionsEdit from '~/modules/recipeInstructions/edit.jsx'


export default class RecipeDetails extends Reflux.Component {
	constructor(props) {
		super(props)

		CurrentRecipeActions.reset()

		this.store = CurrentRecipeStore
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	componentDidMount() {
		CurrentRecipeActions.get(this.props.match.params.recipeID)
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	handleChangeField = (event) => {
		this.setState({ [event.target.name]: event.target.value })
	}

	// --------------------------------------------------------------------------------
	// --------------------------------------------------------------------------------

	render() {
		const isLoaded = this.state.recipeID > 0

		return (isLoaded)
			? (
				<OnlyIfAuthorized>
					<Container>
						<Row>
							<Col>
								<h2 style={{ marginTop: 0, borderBottom: '1px solid #ccc' }}>
									{ this.state.recipe }
									<div className="float-right">
										<Link to={`/recipe/${this.props.match.params.recipeID}/`}>
											<Button
												color="success"
											>
												<FontAwesome
													name="save"
												/>
												{' '}
												Done Editing
											</Button>
										</Link>
										{' '}
										<Link to={`/recipe/${this.props.match.params.recipeID}/`}>
											<Button
												color="warning"
											>
												<FontAwesome
													name="ban"
												/>
												{' '}
												Cancel
											</Button>
										</Link>
									</div>
								</h2>

								<br />

								<RecipeEditGeneral />
							</Col>
						</Row>
						<Row>
							<Col>
								<Card>
									<CardHeader>
										Ingredients
									</CardHeader>
									<CardBody>
										<Alert type="info">
											<Container fluid>
												<Row>
													<Col>
														1/8 = 0.125
													</Col>
													<Col>
														1/4 = 0.25
													</Col>
													<Col>
														3/8 = 0.375
													</Col>
													<Col>
														1/2 = 0.5
													</Col>
													<Col>
														5/8 = 0.625
													</Col>
													<Col>
														3/4 = 0.75
													</Col>
													<Col>
														7/8 = 0.875
													</Col>
												</Row>
											</Container>
										</Alert>

										<br />

										<RecipeEditIngredientsEdit />
									</CardBody>
								</Card>
							</Col>
						</Row>
						<Row>
							<Col>
								<Card>
									<CardHeader>
										Instructions
									</CardHeader>
									<CardBody>
										<RecipeEditInstructionsEdit />
									</CardBody>
								</Card>
							</Col>
						</Row>
					</Container>
				</OnlyIfAuthorized>
			)
			: <div>loading...</div>
	}
}



// WEBPACK FOOTER //
// ./src/modules/details/edit.jsx